<mat-drawer-container id="corely-layout" class="min-h-screen bg-white flex flex-col" fullscreen>
	<corely-toolbar></corely-toolbar>

	<div id="content" class="flex-1 bg-gray-50 flex flex-col">
		<div id="main-content" class="flex-1">
			<router-outlet></router-outlet>
		</div>
		<app-footer></app-footer>
	</div>
</mat-drawer-container>
